import { styled } from '@mui/material/styles';

interface AuthMainLayoutProps {
  open: boolean;
}

export const AuthMainLayout = styled('main', {
  shouldForwardProp: (prop) => prop !== 'open',
})<AuthMainLayoutProps>(({ theme, open }) => ({
  flexGrow: 1,
  width: 0,
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));
